/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authActions from '../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../hooks/useAuthorizedEpApps';
import config from '../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import HomePageLayout from '../../components/HomePageComp/HomePageLayout';
import Welcome from '../WelcomePage/WelcomePage';
import { saveLogToBackend } from '../../api';
import BusinessStructure from '../../components/HomePageComp/BusinessStructure';


const HomePage = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();
  const [flag, setflag] = useState(true)

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorizedApps, currentUserId]);

  const logData = {
    username: localStorage.getItem("preferred_username") || "anonymous",
    page: window.location.pathname,
    method: "PAGE_VISIT",
    url: window.location.href,
    status: "SUCCESS",
    duration: 0,
    timestamp: new Date().toISOString(),
  };

  useEffect(() => {
    saveLogToBackend(logData);
    setTimeout(() => {
      setflag(false)
    }, 2500)
  })

  return (
    <>
      {/* {
        flag ?
          <Welcome /> : <div
            style={{
              transform: 'scale(0.8)',
              width: '100%',
              height: '0%',
            }}
          >
            <HomePageLayout />
          </div>
      } */}
      <div>
        <BusinessStructure />
      </div>
    </>
  )
}

HomePage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(HomePage);
